// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TasksViewForm from './data'

export default function TasksViewFormFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TasksViewForm">
      <TasksViewForm {...props}>
        {children}
      </TasksViewForm>
    </Flow>
  )
}
